import {
  IFrameConsumerEndpoint,
  WorkerConsumerEndpoint,
} from '@wix/editor-platform-transport';

import {
  ApplicationContext,
  EnvironmentContext,
} from '@wix/editor-platform-contexts';
import { PlatformWorkerAPI, PlatformFrameAPI } from './api';
import {
  createEditorPlatformEnvironmentAPIError,
  EditorPlatformEnvironmentAPIErrorErrorCode,
} from './errors';

const GUARD_PROP = '$_EP_TRANSPORT_ENV_CONTEXT_GUARD';

declare global {
  // eslint-disable-next-line no-var
  var $_EP_TRANSPORT_ENV_CONTEXT_GUARD: boolean;
}

export class EditorPlatformContextEnvironment {
  isEnvironmentApiExposed() {
    return !!globalThis[GUARD_PROP];
  }

  async getContexts() {
    const [environmentContext, applicationContext] = await Promise.all([
      EnvironmentContext.getInstance(),
      ApplicationContext.getInstance(),
    ]);

    return {
      environmentContext,
      applicationContext,
    };
  }

  expose() {
    if (this.isEnvironmentApiExposed()) {
      return;
    }

    const isWorker = typeof importScripts === 'function';
    const isIframe =
      globalThis.self && globalThis.top && globalThis.self !== globalThis.top;

    /**
     * TODO: we can try to split this code somehow
     * and load the only API according to the current env.
     */
    if (isWorker) {
      this.#exposeWorkerAPI();
      globalThis[GUARD_PROP] = true;
    } else if (isIframe) {
      this.#exposeFrameAPI();
      globalThis[GUARD_PROP] = true;
    } else {
      /**
       * we expose env APIs only from worker or frame
       * but we have some cases when our code runs in the main thread
       * for example – builder component panels.
       */
      // if (!shouldPreventErrorLogs) {
      //   console.error(
      //     createEditorPlatformEnvironmentAPIError(
      //       EditorPlatformEnvironmentAPIErrorErrorCode.IncorrectExpose,
      //       'seems current code is running in the main thread, while it is expected to be in iframe or worker',
      //     ),
      //   );
      // }
    }
  }

  #exposeWorkerAPI() {
    WorkerConsumerEndpoint.exposeAPI(new PlatformWorkerAPI());
  }

  #exposeFrameAPI() {
    IFrameConsumerEndpoint.exposeAPI(new PlatformFrameAPI());
  }
}
